<template>
  <div
    style="
      background: url('/img/bg-1.png') no-repeat left;
      background-size: contain;
      height: 100vh;
      overflow: auto;
    "
  >
    <div v-if="isLoading" class="loading-overlay">
      <loading
        loader="dots"
        :height="170"
        :width="170"
        color="#3282b8"
        background-color="#505273"
        transition="fade"
        :active="isLoading"
        :is-full-page="true"
      ></loading>
    </div>
    <div>
      <modal :show.sync="modals.successModal">
        <div
          class="modal-header"
          style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #16cf79;
          "
        >
          <div class="col-lg"></div>
          <div class="col-lg-5">
            <div
              style="
                padding: 15px;
                background-color: transparent;
                border-radius: 100px;
                border: 10px solid white;
              "
            >
              <i
                style="color: white; font-size: 90px; font-weight: 900"
                class="tim-icons icon-check-2"
              ></i>
            </div>
            <div>
              <p
                style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                "
              >
                Successful
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="col-lg-12 text-center">
          <p
            style="
              margin-top: 50px;
              font-size: 40px;
              font-weight: 500;
              color: #606060;
            "
          >
            Congratulations!
          </p>

          <p style="color: #a8a8a8">
            Your account has been successfully created
          </p>

          <div style="display: flex">
            <p style="color: #a8a8a8">Please allow</p>
            &nbsp;
            <p style="font-weight: 600; color: #707070">3 working days</p>
            &nbsp;
            <p style="color: #a8a8a8">for your registration approval</p>
          </div>

          <p style="color: #a8a8a8; margin-top: 20px">
            Click 'Continue' to proceed to login page
          </p>
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <base-button type="primary" v-on:click="getLogin()"
              >Continue</base-button
            >
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.failedModal">
        <div
          class="modal-header"
          style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #EC1B23;
            text-align: center;
          "
        >
          <!-- <div class="col-lg"></div> -->
          <div class="col-lg-12">
            <div>
              <i
                style="color: white; font-size: 120px; font-weight: 900"
                class="tim-icons icon-alert-circle-exc"
              ></i>
            </div>
            <div>
              <p
                style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                "
              >
                Failed
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="col-lg-12 text-center">
          <p
            style="
              margin-top: 50px;
              font-size: 40px;
              font-weight: 500;
              color: #606060;
            "
          >
            Warning!
          </p>

          <p style="color: #a8a8a8">Please fill in all the details.</p>

          <p style="color: #a8a8a8; margin-top: 20px">
            Click 'Retry' to go back.
          </p>
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <base-button type="danger" v-on:click="getLogin()">Exit</base-button
            >&nbsp;
            <base-button type="primary" v-on:click="closeFailedModal()"
              >Retry</base-button
            >
          </div>
        </div>
      </modal>
      <div class="full-page">
        <!-- <div class="full-page" :class="pageClass"> -->
        <div class="content">
          <div class="row">
            <div style="margin-top: -70px" class="col-lg-12 text-center">
              <p style="font-size: 29px; color: #358CCB">Sign Up</p>
            </div>
          </div>
          <div class="row">
            <div
              style="margin-top: -30px; margin-bottom: 50px"
              class="col-lg-12 text-center"
            >
              <p style="font-size: 18px; color: #b9b9b9">
                Please fill up the information to register
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6">
              <card
                style="
                  box-shadow: none;
                  padding: 30px 0px 30px 30px;
                  height: 630px;
                  background-color: white;
                "
              >
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  SHIP DETAILS
                </p>
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-6">
                      <p style="color: #A5A5A5; opacity: 0.7">Ship Name</p>
                      <div style="padding-right: 30px">
                        <input
                          type="text"
                          v-model="shipname"
                          :class="{ 'custom-input': true }"
                        />
                      </div>

                      <p style="color: #A5A5A5; opacity: 0.7">IMO No.</p>
                      <div style="padding-right: 30px">
                        <input
                          type="text"
                          v-model="imono"
                          :class="{ 'custom-input': true }"
                        />
                      </div>
                      <p
                        style="
                          color: #A5A5A5;
                          font-size: 10px;
                          margin-top: -1px;
                        "
                      >
                        {{ this.imono_unique }}
                      </p>

                      <p style="color: #A5A5A5; opacity: 0.7">Ship Type</p>
                      <!-- @change="getType()" -->
                      <el-select
                        class="select-info tab select-width"
                        popper-class="custom-dropdown"
                        placeholder="Select"
                        v-model="selects.ship"
                        style="width: 90%; border-bottom: 1px solid lightgray"
                        filterable
                      >
                        <el-option
                          v-for="option in selects.ships"
                          class="select-info custom-option"
                          :value="option.value"
                          :label="option.label"
                          :key="option.value"
                        ></el-option>
                      </el-select>
                      <div
                        v-if="this.selects.ship == '8'"
                        style="padding-right: 30px; padding-top: 20px"
                      >
                        <input
                          type="text"
                          v-model="specify"
                          :class="{ 'custom-input': true }"
                        />
                      </div>

                      <p style="color: #A5A5A5; opacity: 0.7">Gross Tonnage</p>
                      <div style="padding-right: 30px">
                        <input
                          type="text"
                          v-model="grosstonnage"
                          :class="{ 'custom-input': true }"
                        />
                      </div>

                      <p style="color: #A5A5A5; opacity: 0.7">
                        Deadweight Tonnage (kg)
                      </p>
                      <div style="padding-right: 30px">
                        <input
                          type="text"
                          v-model="deadweight"
                          :class="{ 'custom-input': true }"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <p style="color: #A5A5A5; opacity: 0.7">
                        Owner / Operator Name
                      </p>
                      <div style="padding-right: 30px">
                        <input
                          type="text"
                          v-model="ownername"
                          :class="{ 'custom-input': true }"
                        />
                      </div>

                      <p style="color: #A5A5A5; opacity: 0.7">Call Sign</p>
                      <div style="padding-right: 30px">
                        <input
                          type="text"
                          v-model="callsign"
                          :class="{ 'custom-input': true }"
                        />
                      </div>

                      <p style="color: #A5A5A5; opacity: 0.7">Flag State</p>
                      <!-- @change="getType()" -->
                      <el-select
                        class="select-info tab select-width"
                        placeholder="Select"
                        v-model="selects.state"
                        style="width: 90%; border-bottom: 1px solid lightgray"
                        filterable
                      >
                        <el-option
                          v-for="option in selects.states"
                          class="select-info"
                          :value="option.value"
                          :label="option.label"
                          :key="option.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-lg-3">
              <card
                style="box-shadow: none; height: 630px; background-color: white"
              >
                <p
                  style="
                    color: #358CCB;
                    font-size: 24px;
                    font-weight: 300;
                    padding: 30px;
                  "
                >
                  SUSTAINABLE CERTIFICATES
                </p>
                <div
                  class="w-100 p-4 d-flex align-items-center justify-content-center"
                  style="height: 250px"
                >
                  <div
                    class="w-100 p-4 d-flex align-items-center justify-content-center"
                    style="
                      border: 2px dashed #dcdcdc;
                      height: 280px;
                      width: 350px;
                    "
                  >
                    <div class="col-lg-12 text-center">
                      <i
                        style="
                          color: lightgray;
                          font-size: 90px;
                          font-weight: 500;
                          margin-bottom: 10px;
                        "
                        class="tim-icons icon-upload"
                      ></i>

                      <p style="font-weight: 600; color: #787878">
                        Drop files to upload
                      </p>
                      <div class="row">
                        <div class="col-lg"></div>

                        <p style="font-weight: 600; color: #787878">or</p>
                        &nbsp;
                        <div class="fileinput">
                          <label for="file-upload">
                            <p
                              style="
                                font-weight: 600;
                                font-size: 14px;
                                color: #5e99ff;
                                text-decoration: underline;
                                cursor: pointer;
                              "
                            >
                              browse
                            </p>
                          </label>
                          <input
                            accept="application/pdf"
                            id="file-upload"
                            ref="file"
                            type="file"
                            name="..."
                            class="valid"
                            :multiple="true"
                            aria-invalid="false"
                            style="display: none"
                            v-on:change="onFileChange"
                          />
                        </div>

                        <div class="col-lg"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  style="
                    height: 200px;
                    padding: 20px;
                    margin: 30px 30px 20px 0px;
                  "
                  class="d-flex justify-content-center spinner"
                  v-if="this.uploadload == true"
                >
                  <circle-8></circle-8>
                </div>

                <div
                  v-if="this.uploadload == false"
                  style="
                    height: 200px;
                    padding: 20px;
                    margin: 30px 30px 20px 0px;
                  "
                  class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
                >
                  <div
                    v-for="(file, index) in allfilename"
                    :key="index"
                    class="row"
                  >
                    <div class="col-lg-8">
                      <p
                        style="padding-left: 15px; color: #aaaaaa"
                        v-if="selectedFileName"
                        id="file-name"
                      >
                        {{ allfilename[index] }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <base-button
                        v-if="selectedFileName"
                        class="btn-sm btn-cancel"
                        style="font-size: 12px"
                        @click="removeFile(index)"
                      >
                        Remove
                      </base-button>
                    </div>
                  </div>

                  <div
                    v-for="(file, index) in support_doc_list"
                    :key="index"
                    class="row"
                  >
                    <div class="col-lg-8">
                      <p
                        style="padding-left: 15px; color: #A5A5A5; opacity: 0.7"
                        id="file-name"
                      >
                        {{ support_doc_list[index] }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <base-button
                        class="btn-sm btn-cancel"
                        style="font-size: 12px"
                        @click="removeFile2(index)"
                      >
                        Remove
                      </base-button>
                    </div>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-lg"></div>
          </div>
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6"></div>
            <div class="col-lg-3 text-right">
              <base-button type="danger" v-on:click="getBack()"
                >Back</base-button
              >&nbsp;
              <base-button
                type="primary"
                :disabled="buttondisabled"
                v-on:click="handleDone()"
                >Done</base-button
              >
            </div>
          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Alert } from "element-ui";
import swal from "sweetalert2";
import Card from "../../../components/Cards/Card.vue";
import { Modal } from "../../../components";
import { Select, Option, Checkbox } from "element-ui";
import { Circle8 } from "vue-loading-spinner";
import { debounce } from "src/util/debounce";
import Loading from "vue-loading-overlay";

export default {
  name: "VesselRegistration-1",
  components: {
    Card,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    Modal,
    [Checkbox.name]: Checkbox,
    Circle8,
    Loading,
  },

  data() {
    return {
      buttondisabled: false,
      isLoading: false,
      imono_unique: "",
      selectedFileName: "",
      allfilename: [],

      positionID: 0,
      roleID: 0,

      pic: [],
      addPIC: false,

      specify: "",

      //data from user
      companyname: "",
      operationtype: 0,
      companyaddress: "",
      phoneno: "",
      faxno: "",
      supportdoc: "",

      fullname: "",
      password: "",
      confirmpassword: "",
      phoneno1: "",
      faxno1: "",
      email: "",

      fullname2: "",
      password2: "",
      confirmpassword2: "",
      phoneno2: "",
      faxno2: "",
      email2: "",

      shipname: "",
      imono: "",
      shiptype: "",
      grosstonnage: "",
      deadweight: "",
      ownername: "",
      callsign: "",
      flagstate: "",

      selects: {
        ship: "",
        ships: [],

        state: "",
        states: [],
      },

      modals: {
        successModal: false,
        failedModal: false,
      },

      docs: "",
      document: 0,

      documentID: [],
      document_ID: [],
      document_ID2: [],

      support_doc: "",
      support_doc_list: [],

      uploadload: false,

      shiptypevalue: 0,
      flag: 0,
    };
  },
  watch: {
    imono: debounce(function () {
      this.imono_unique = "";

      let obj = {
        imo_number: this.imono,
      };

      this.$http
        .post(":10001/api/v1/helper/check-ship-imo", obj)
        .then((res) => {
          let response = res.message;
          if (!res.error) {
            this.imono_unique = response;
            this.buttondisabled = false;
          } else if (res.error) {
            this.imono_unique = response.error_message;
            this.buttondisabled = true;
          } else {
            this.imono_unique = "";
            this.buttondisabled = false;
          }
        })
        .catch((err) => {
          console.log(err.response.data.message);
          this.imono_unique = err.response.data.message;
        });
      this.imono_unique = "";
    }, 500),
  },
  methods: {
    getIndex() {
      return this.selects.ships.findIndex(
        (option) => option.value === this.selects.ship
      );
    },

    getIndex1() {
      return this.selects.states.findIndex(
        (option) => option.value === this.selects.state
      );
    },
    // successModal() {
    //   this.modals.successModal = true;
    // },
    // failedModal() {
    //   this.modals.failedModal = true;
    // },
    // closeFailedModal() {
    //   this.modals.failedModal = false;
    // },
    getLogin() {
      sessionStorage.removeItem("position-id");
      sessionStorage.removeItem("role-id");
      sessionStorage.removeItem("vessel-add-pic");
      sessionStorage.removeItem("vessel-support-doc");
      sessionStorage.removeItem("vessel-support-doc-1");

      sessionStorage.removeItem("vessel-company-name");
      sessionStorage.removeItem("vessel-operation-type");
      sessionStorage.removeItem("vessel-operation-type-value");
      sessionStorage.removeItem("vessel-company-address");
      sessionStorage.removeItem("vessel-phone-no");
      sessionStorage.removeItem("vessel-fax-no");

      sessionStorage.removeItem("vessel-full-name");
      sessionStorage.removeItem("vessel-email");
      sessionStorage.removeItem("vessel-phone-no1");
      sessionStorage.removeItem("vessel-fax-no1");
      sessionStorage.removeItem("vessel-password");
      sessionStorage.removeItem("vessel-confirm-password");

      sessionStorage.removeItem("vessel-full-name2");
      sessionStorage.removeItem("vessel-email2");
      sessionStorage.removeItem("vessel-phone-no2");
      sessionStorage.removeItem("vessel-fax-no2");
      sessionStorage.removeItem("vessel-password2");
      sessionStorage.removeItem("vessel-confirm-password2");

      sessionStorage.removeItem("vessel-ship-name");
      sessionStorage.removeItem("vessel-imo-no");
      sessionStorage.removeItem("vessel-ship-type-value");
      sessionStorage.removeItem("vessel-ship-type-specify");
      sessionStorage.removeItem("vessel-flag");

      sessionStorage.removeItem("vessel-gross-tonnage");
      sessionStorage.removeItem("vessel-dead-weight");
      sessionStorage.removeItem("vessel-owner-name");
      sessionStorage.removeItem("vessel-call-sign");
      // sessionStorage.removeItem("vessel-ship-doc");

      this.$router.push("/login");
    },
    getBack() {
      // sessionStorage.setItem("vessel-ship-type-value", this.getIndex());
      if (this.selects.ship != 8) {
        sessionStorage.setItem("vessel-ship-type-value", this.getIndex());
      } else {
        let obj = {
          ship_type_name: this.specify,
        };

        this.$http.post(":10001/api/v1/setting/ship_types", obj).then((res) => {
          if (!res.error) {
            let response = res.message;

            sessionStorage.setItem(
              "vessel-ship-type-value",
              parseInt(response.ship_type_id)
            );
            sessionStorage.setItem("vessel-ship-type-value", this.getIndex());
            this.selects.ship = parseInt(response.ship_type_id);

            console.log("jadi");
          } else {
            console.log("xjadi");
          }
        });
      }

      sessionStorage.setItem("vessel-flag", this.getIndex1());

      sessionStorage.setItem("vessel-ship-name", this.shipname);
      sessionStorage.setItem("vessel-imo-no", this.imono);
      sessionStorage.setItem("vessel-gross-tonnage", this.grosstonnage);
      sessionStorage.setItem("vessel-dead-weight", this.deadweight);
      sessionStorage.setItem("vessel-owner-name", this.ownername);
      sessionStorage.setItem("vessel-call-sign", this.callsign);
      sessionStorage.setItem("vessel-ship-type-specify", this.specify);
      this.$router.push("/vessel-register");
    },
    onFileChange(event) {
      const t = event.target;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          this.selectedFileName = t.files[i].name;
          this.allfilename.push(this.selectedFileName);
        }
        sessionStorage.setItem("vessel-support-doc-1", this.allfilename);
      } else {
        this.selectedFileName = "";
      }

      this.document = t.files.length;

      var input;

      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.file.files[i];
          const formData = new FormData();
          formData.append("document", input);
          this.docs = formData;

          this.uploadload = true;
          this.buttondisabled = true;

          this.$http
            .post(":10001/api/v1/upload/ship_support_document", this.docs, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                console.log("data masuk", response);
                this.document_ID.push(response.document_id);
              } else {
                console.log("data tak masuk");
              }
            }).cathc;
          this.uploadload = false;
          this.buttondisabled = false;
        }
      }
    },
    removeFile(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
        this.allfilename.splice(indexToRemove, 1);
        this.document_ID.splice(indexToRemove, 1);
      }
      this.$emit("change", null);
    },
    removeFile2(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.support_doc_list.length) {
        this.documentID.splice(indexToRemove, 1);
        this.support_doc_list.splice(indexToRemove, 1);
      }
      sessionStorage.setItem("vessel-support-doc-1", this.support_doc_list);
      // this.$emit("change", null);
    },
    getShipType() {
      (this.selects.ships = []),
        this.$http.get(":10001/api/v1/setting/ship_types").then((res) => {
          if (!res.error) {
            let response = res.message;

            console.log("data here", response);

            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].ship_type_name,
                value: response[i].ship_type_id,
              };

              this.selects.ships.push(obj);
            }

            //default value
            if (typeof this.shiptypevalue === "number") {
              this.selects.ship = this.selects.ships[this.shiptypevalue].value;
            } else {
              this.selects.ship = this.selects.ships[0].value;
            }
          }
        });
    },
    getFlagState() {
      this.selects.states = [];
      this.$http.get(":10001/api/v1/setting/flags").then((res) => {
        if (!res.error) {
          let response = res.message;

          console.log("data here", response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].country_name,
              value: response[i].flag_id,
            };

            this.selects.states.push(obj);
          }

          //default value
          if (typeof this.flag === "number") {
            this.selects.state = this.selects.states[this.flag].value;
          } else {
            this.selects.state = this.selects.states[0].value;
          }
        }
      });
    },
    handleDone() {
      this.isLoading = true;

      let pic1 = {
        user_name: this.fullname,
        user_email: this.email,
        user_phone_number: this.phoneno1,
        user_fax_number: this.faxno1,
        password: this.password,
        confirm_password: this.confirmpassword,
      };
      this.pic.push(pic1);

      if (this.addPIC == "true") {
        let pic2 = {
          user_name: this.fullname2,
          user_email: this.email2,
          user_phone_number: this.phoneno2,
          user_fax_number: this.faxno2,
          password: this.password2,
          confirm_password: this.confirmpassword2,
        };
        this.pic.push(pic2);
      }
      let obj = {
        position_id: parseInt(this.positionID),
        role_id: parseInt(this.roleID),
        company_name: this.companyname,
        operation_type_id: parseInt(this.operationtype),
        company_address: this.companyaddress,
        company_phone_number: this.phoneno,
        company_fax_number: this.faxno,
        documents: this.document_ID2, //required

        pic: this.pic,

        ship: {
          ship_name: this.shipname,
          imo_number: this.imono,
          ship_type_id: parseInt(this.selects.ship),
          gross_tonnage: parseInt(this.grosstonnage),
          deadweight_tonnage: parseInt(this.deadweight),
          operator_name: this.ownername,
          call_sign: this.callsign,
          flag_id: parseInt(this.selects.state),
          ship_documents: this.document_ID, //required
        },
      };

      console.log("datas", obj);

      this.$http
        .post(":10001/api/v1/register/customer_vessel", obj)
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Registration success.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                sessionStorage.removeItem("position-id");
                sessionStorage.removeItem("role-id");
                sessionStorage.removeItem("vessel-add-pic");
                sessionStorage.removeItem("vessel-support-doc");
                sessionStorage.removeItem("vessel-support-doc-1");

                sessionStorage.removeItem("vessel-company-name");
                sessionStorage.removeItem("vessel-operation-type");
                sessionStorage.removeItem("vessel-operation-type-value");
                sessionStorage.removeItem("vessel-company-address");
                sessionStorage.removeItem("vessel-phone-no");
                sessionStorage.removeItem("vessel-fax-no");

                sessionStorage.removeItem("vessel-full-name");
                sessionStorage.removeItem("vessel-email");
                sessionStorage.removeItem("vessel-phone-no1");
                sessionStorage.removeItem("vessel-fax-no1");
                sessionStorage.removeItem("vessel-password");
                sessionStorage.removeItem("vessel-confirm-password");

                sessionStorage.removeItem("vessel-full-name2");
                sessionStorage.removeItem("vessel-email2");
                sessionStorage.removeItem("vessel-phone-no2");
                sessionStorage.removeItem("vessel-fax-no2");
                sessionStorage.removeItem("vessel-password2");
                sessionStorage.removeItem("vessel-confirm-password2");

                sessionStorage.removeItem("vessel-ship-name");
                sessionStorage.removeItem("vessel-imo-no");
                sessionStorage.removeItem("vessel-ship-type-value");
                sessionStorage.removeItem("vessel-ship-type-specify");

                sessionStorage.removeItem("vessel-flag");

                sessionStorage.removeItem("vessel-gross-tonnage");
                sessionStorage.removeItem("vessel-dead-weight");
                sessionStorage.removeItem("vessel-owner-name");
                sessionStorage.removeItem("vessel-call-sign");

                this.$router.push("/login");
              }
            });
          } else {
            console.log("ewor");
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Registration failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });

      this.isLoading = false;
    },
  },
  mounted() {
    this.positionID = sessionStorage.getItem("position-id");
    this.roleID = sessionStorage.getItem("role-id");
    this.addPIC = sessionStorage.getItem("vessel-add-pic");
    // this.documentID = sessionStorage.getItem("vessel-support-doc");
    this.document_ID2 = sessionStorage.getItem("vessel-support-doc");
    console.log(this.document_ID2);
    // this.documentID.split(",").map(Number);

    this.companyname = sessionStorage.getItem("vessel-company-name");
    this.operationtype = sessionStorage.getItem("vessel-operation-type");
    this.companyaddress = sessionStorage.getItem("vessel-company-address");
    this.phoneno = sessionStorage.getItem("vessel-phone-no");
    this.faxno = sessionStorage.getItem("vessel-fax-no");

    this.fullname = sessionStorage.getItem("vessel-full-name");
    this.email = sessionStorage.getItem("vessel-email");
    this.phoneno1 = sessionStorage.getItem("vessel-phone-no1");
    this.faxno1 = sessionStorage.getItem("vessel-fax-no1");
    this.password = sessionStorage.getItem("vessel-password");
    this.confirmpassword = sessionStorage.getItem("vessel-confirm-password");

    this.fullname2 = sessionStorage.getItem("vessel-full-name2");
    this.email2 = sessionStorage.getItem("vessel-email2");
    this.phoneno2 = sessionStorage.getItem("vessel-phone-no2");
    this.faxno2 = sessionStorage.getItem("vessel-fax-no2");
    this.password2 = sessionStorage.getItem("vessel-password2");
    this.confirmpassword2 = sessionStorage.getItem("vessel-confirm-password2");

    this.shipname =
      sessionStorage.getItem("vessel-ship-name") !== null &&
      sessionStorage.getItem("vessel-ship-name") !== "null"
        ? sessionStorage.getItem("vessel-ship-name")
        : "";

    this.imono =
      sessionStorage.getItem("vessel-imo-no") !== null &&
      sessionStorage.getItem("vessel-imo-no") !== "null"
        ? sessionStorage.getItem("vessel-imo-no")
        : "";

    this.grosstonnage =
      sessionStorage.getItem("vessel-gross-tonnage") !== null &&
      sessionStorage.getItem("vessel-gross-tonnage") !== "null"
        ? sessionStorage.getItem("vessel-gross-tonnage")
        : "";

    this.deadweight =
      sessionStorage.getItem("vessel-dead-weight") !== null &&
      sessionStorage.getItem("vessel-dead-weight") !== "null"
        ? sessionStorage.getItem("vessel-dead-weight")
        : "";

    this.ownername =
      sessionStorage.getItem("vessel-owner-name") !== null &&
      sessionStorage.getItem("vessel-owner-name") !== "null"
        ? sessionStorage.getItem("vessel-owner-name")
        : "";

    this.callsign =
      sessionStorage.getItem("vessel-call-sign") !== null &&
      sessionStorage.getItem("vessel-call-sign") !== "null"
        ? sessionStorage.getItem("vessel-call-sign")
        : "";

    this.shiptypevalue =
      sessionStorage.getItem("vessel-ship-type-value") !== null &&
      sessionStorage.getItem("vessel-ship-type-value") !== "null"
        ? sessionStorage.getItem("vessel-ship-type-value")
        : "";

    this.shiptypevalue = parseInt(this.shiptypevalue);

    this.specify =
      sessionStorage.getItem("vessel-ship-type-specify") !== null &&
      sessionStorage.getItem("vessel-ship-type-specify") !== "null"
        ? sessionStorage.getItem("vessel-ship-type-specify")
        : "";

    this.flag =
      sessionStorage.getItem("vessel-flag") !== null &&
      sessionStorage.getItem("vessel-flag") !== "null"
        ? sessionStorage.getItem("vessel-flag")
        : "";

    this.flag = parseInt(this.flag);

    this.support_doc =
      sessionStorage.getItem("vessel-support-doc-1") !== null &&
      sessionStorage.getItem("vessel-support-doc-1") !== "null"
        ? sessionStorage.getItem("vessel-support-doc-1")
        : "";

    // this.support_doc = sessionStorage.getItem("vessel-support-doc-1");
    // this.allfilename = this.support_doc.split(",").map(String);
    // this.support_doc_list = this.allfilename;

    this.support_doc = sessionStorage.getItem("vessel-support-doc-1");

    if (this.support_doc) {
      this.support_doc_list = this.support_doc.trim().split(",").map(String);
    } else {
      this.support_doc_list = [];
    }
  },
  created() {
    this.getShipType();
    this.getFlagState();
  },
  computed: {},
};
</script>
<style scoped>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.scrollable {
  height: 60px;
  overflow-y: scroll;
  color: #A5A5A5;
}

.custom-dropdown .el-select-dropdown {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-option {
  color: #333;
  background-color: #fff;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
</style>
